(function () {
  // ===== CONFIG =====
  var COLLECTION_HANDLE = 'integratori'; // handle della collezione 413361034
  var PARAM = 'sd2active';
  var PROP = '_omaggio';
  // ==================

  /*
  var qs = new URLSearchParams(location.search);
  if (qs.get(PARAM) === '1') sessionStorage.setItem('sd2active', '1');
  if (qs.get(PARAM) === '0') sessionStorage.removeItem('sd2active');
  if (sessionStorage.getItem('sd2active') !== '1') return;
  */

  console.log('[sd22] attivo');

  var syncing = false;
  var pendingSync = false;
  var promoHandles = null;

  function loadPromoHandles() {
    if (promoHandles) return Promise.resolve(promoHandles);
    var cached = sessionStorage.getItem('promo22_handles');
    if (cached) { promoHandles = JSON.parse(cached); return Promise.resolve(promoHandles); }
    return fetch('/collections/' + COLLECTION_HANDLE + '/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        promoHandles = data.products.map(function (p) { return p.handle; });
        sessionStorage.setItem('promo22_handles', JSON.stringify(promoHandles));
        console.log('[promo22] prodotti in promo:', promoHandles);
        return promoHandles;
      });
  }

  function computeOps(cart, handles) {
    var paidOrder = [];
    var paid = {};
    var gifts = {}; // variant_id -> [{qty, key}, ...] (possono esserci duplicati)

    cart.items.forEach(function (item) {
      if (handles.indexOf(item.handle) === -1) return;
      if (item.properties && item.properties[PROP]) {
        if (!gifts[item.variant_id]) gifts[item.variant_id] = [];
        gifts[item.variant_id].push({ qty: item.quantity, key: item.key });
      } else {
        if (!paid[item.variant_id]) paidOrder.push(item.variant_id);
        paid[item.variant_id] = (paid[item.variant_id] || 0) + item.quantity;
      }
    });

    var totalPaid = paidOrder.reduce(function (s, v) { return s + paid[v]; }, 0);
    var giftBudget = Math.floor(totalPaid / 2) * 2;

    // allocazione stabile: prima le varianti con più pagate, tie-break per variant id
    var allocOrder = paidOrder.slice().sort(function (a, b) {
      return (paid[b] - paid[a]) || (parseInt(a, 10) - parseInt(b, 10));
    });

    var target = {};
    allocOrder.forEach(function (vid) {
      var t = Math.min(paid[vid], giftBudget);
      target[vid] = t;
      giftBudget -= t;
    });

    var ops = [];

    // righe omaggio esistenti: consolida sulla prima, azzera i duplicati
    Object.keys(gifts).forEach(function (vid) {
      var t = target[vid] || 0;
      gifts[vid].forEach(function (line, index) {
        if (!line.key) return;
        var wanted = index === 0 ? t : 0;
        if (line.qty !== wanted) {
          ops.push({ change: { id: line.key, quantity: wanted } });
        }
      });
    });

    // omaggi mancanti
    paidOrder.forEach(function (vid) {
      if (!gifts[vid] && target[vid] > 0) {
        var props = {}; props[PROP] = 'true';
        ops.push({ add: { id: parseInt(vid, 10), quantity: target[vid], properties: props } });
      }
    });

    return ops;
  }

  function runOps(ops) {
    var chain = Promise.resolve();
    ops.forEach(function (op) {
      chain = chain.then(function () {
        var req = op.add
          ? fetch(Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [op.add] })
            })
          : fetch(Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: op.change.id, quantity: op.change.quantity })
            });
        // un'op fallita non interrompe la catena: la convergenza corregge al giro dopo
        return req.then(function (r) {
          if (!r.ok) console.warn('[promo22] op fallita (' + r.status + '), continuo:', op);
        }).catch(function (e) {
          console.warn('[promo22] op errore di rete, continuo:', op, e);
        });
      });
    });
    return chain;
  }

  function convergeLoop(handles, iteration) {
    if (iteration >= 4) {
      console.warn('[promo22] convergenza non raggiunta, stop');
      return Promise.resolve(true);
    }
    return fetch(Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ops = computeOps(cart, handles);
        if (!ops.length) return iteration > 0;
        console.log('[promo22] iterazione', iteration, 'ops:', ops);
        return runOps(ops).then(function () {
          return convergeLoop(handles, iteration + 1);
        });
      });
  }

  function finishSync(didChange) {
    syncing = false;
    if (didChange) {
      if (window.themeVariables && window.themeVariables.settings.pageType === 'cart') {
        location.reload();
        return;
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
    if (pendingSync) {
      pendingSync = false;
      sync();
    }
  }

  function sync() {
    if (syncing) { pendingSync = true; return; }
    syncing = true;
    loadPromoHandles()
      .then(function (handles) { return convergeLoop(handles, 0); })
      .then(finishSync)
      .catch(function (e) {
        console.warn('[promo22] sync fallito', e);
        finishSync(false);
      });
  }

  document.addEventListener('cart:change', function () {
    sync();
  });

  document.addEventListener('DOMContentLoaded', function () { sync(); });
})();